import React from 'react';
import styled from 'styled-components';
import Container from '../../components/Container/Container';
import theme from '../../styles/theme';
import { getFormattedDate } from '../../helpers/utilities';
import { amountSToB } from '../../helpers/utilities'
import { useTranslation } from 'react-i18next';
import { getMarketImageSrc } from '../../helpers/market-images';


const DetailsHeader = ({market}) => {
  const { t, i18n } = useTranslation();
  const marketImageSrc = market ? getMarketImageSrc(market.image_url) : '';

  return (
    <Container>
      <Header>
        <Ttitle>
          <img src={marketImageSrc} alt="" />
          <TextContent>
            <span className="category">{market && t(`markets.${market.id}.category`)}</span>
            <h1>{market && t(`markets.${market.id}.question`)}</h1>
          </TextContent>
        </Ttitle>
        <Aside>
          <AsideContent>
            {/* <Box>
              <span className="w-normal">{t('market_page.market_ends_on')}</span>
              <span className="w-bold">{market && getFormattedDate(market.market_ends_on)}</span>
            </Box>
            <Box>
              <span className="w-normal">{t('market_page.trade_volume')}</span>
              <span className="w-bold">{market && `$${(amountSToB(market.collateral_volume)).toFixed(2)}`}</span>
            </Box> 
            <Box>
              <span className="w-normal">{t('market_page.liquidity')}</span>
              <span className="w-bold">{market && `$${(amountSToB(market.liquidity_measure)).toFixed(2)}`}</span>
            </Box>
            */}
          </AsideContent>
        </Aside>
      </Header>
    </Container>
  )
}

export default DetailsHeader;

const Header = styled.header`
  display: flex;
  align-items: center;
  padding: 30px 0px 0px 0px;
  margin-bottom: 24px;
  background: linear-gradient(180deg, rgba(12,18,31,0.95) 0%, rgba(8,14,24,0.95) 100%);
  border: none;
  border-radius: 14px;
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.28);
`;

const TextContent = styled.div``;

const Ttitle = styled.div`
  display: flex;
  align-items: center;

  img {
    height: 64px;
    width: 64px;
    border-radius: 12px;
    object-fit: cover;
  }

  ${TextContent} {
    padding-left: 16px;

    .category {
      font-size: 13px;
      color: #9ca3af;
    }
  }

  h1 {
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 800;
    font-size: 25px;
    margin: 6px 25px 0 0;
    color: #fff;
  }
`;

const Aside = styled.aside``;

const AsideContent = styled.div`
  display: flex;
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 7rem;
  padding: 7px 12px;
  white-space: nowrap;
  /* border: 1px solid #718c8e;
  background-color: ${theme.light}; */
  border: 1px solid ${theme.darkBlue};
  background-color: ${theme.light};

  .w-normal {
    font-weight: 400;
    font-size: 12px;
    color: ${theme.mutedText};
  }

  .w-bold {
    font-weight: 500;
    margin: .2rem 0;
    font-size: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:not(:first-child) {
    margin-left: 10px;
  }
`;
